module.exports = __webpack_public_path__ + "static/media/setting.659f29d3.svg";